var _path, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomSizeIconTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_326_526",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2L11.5333 3.53333L9.60667 5.44667L10.5533 6.39333L12.4667 4.46667L14 6V2H10ZM2 6L3.53333 4.46667L5.44667 6.39333L6.39333 5.44667L4.46667 3.53333L6 2H2V6ZM6 14L4.46667 12.4667L6.39333 10.5533L5.44667 9.60667L3.53333 11.5333L2 10V14H6ZM14 10L12.4667 11.5333L10.5533 9.60667L9.60667 10.5533L11.5333 12.4667L10 14H14V10Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_326_526)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.66675,
    y: -8.66675,
    width: 33.3333,
    height: 33.3333,
    fill: "#2800A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_326_526",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -9,
    width: 34,
    height: 34
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -8.66675,
    y: -8.66675,
    width: 33.3333,
    height: 33.3333,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_326_526)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSizeIconTransavia);
export default __webpack_public_path__ + "static/media/room-size-icon-transavia.8ce36e3d353d0ce40261ec546f97ad18.svg";
export { ForwardRef as ReactComponent };